import type { VisioLink } from '@gozoki/api-types'
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { fetchAskVisio } from '../queries/visio.queries'

export const useVisio = (
  kioskId: number | null,
  includeVideo: boolean,
  shouldStartCall: boolean,
): UseQueryResult<VisioLink> =>
  useQuery({
    queryKey: ['visio', kioskId],
    queryFn: () => fetchAskVisio(kioskId as number, includeVideo),
    enabled: shouldStartCall && kioskId !== null,
  })
